import { useQuery } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';

import { fetchData } from '@framework/api/apiCalls';
import { ServerStateKeys } from '@framework/constants/serverStateKeys';

import { api } from '@accounts/constants/endpoints';
import { type AuthenticationStatusResponse } from '@accounts/types/authentication';

const fetchAuthenticationStatus = async () => {
    const response: AxiosResponse<AuthenticationStatusResponse> = await fetchData(
        api.authenticationStatus()
    );

    return response.data?.proofStatus;
};

const useAuthenticationStatus = () => {
    return useQuery({
        queryKey: [ServerStateKeys.AuthenticationStatus],
        queryFn: () => fetchAuthenticationStatus(),
        refetchOnWindowFocus: true
    });
};

export default useAuthenticationStatus;
